import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Private waterways, direct lake access",
    copy: "Every canal in Lagoon City feeds the open water. Your morning commute can be a boat ride — and your backyard, a launch pad.",
  },
  {
    n: "02",
    title: "Year-round resort living",
    copy: "Summer swims and autumn paddles, winter ice trails and spring thaws on the dock. The lagoon never really closes.",
  },
  {
    n: "03",
    title: "Architectural harmony",
    copy: "Custom builds that respect the shoreline — glass, timber and stone tucked between the trees, each address its own point of view.",
  },
  {
    n: "04",
    title: "Relationships built on trust",
    copy: "Near three decades of award-winning sales and services. 98% of business generated by repeat clients and referrals.",
  },
];

export default function ManifestoChapters() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="pt-10 pb-12 sm:pt-14 sm:pb-16 bg-[#0D0B0E]">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-mono text-xs tracking-[0.35em] uppercase text-[#E890A7]/80 mb-4"
        >
          05 · The Lagoon Manifesto
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="font-display font-light text-4xl sm:text-5xl lg:text-6xl mb-16"
        >
          Why life leans <em className="italic text-[#E890A7]">lagoon-side</em>
        </motion.h2>

        <div>
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`manifesto-chapter-${c.n}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.05 }}
              className="group grid md:grid-cols-[120px_1fr_1.2fr] gap-6 items-baseline border-t border-[#E890A7]/12 py-10 hover:bg-[#151218]/50 transition-colors duration-500 px-2 sm:px-6 -mx-2 sm:-mx-6"
            >
              <span className="font-display italic text-5xl sm:text-6xl text-[#E890A7]/25 group-hover:text-[#E890A7]/70 transition-colors duration-500">
                {c.n}
              </span>
              <h3 className="font-display text-2xl sm:text-3xl leading-snug">{c.title}</h3>
              <p className="text-slate-400 font-light leading-relaxed text-sm sm:text-base">{c.copy}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
